import { render, staticRenderFns } from "./LastServiceModal.vue?vue&type=template&id=8bbc21a6"
import script from "./LastServiceModal.vue?vue&type=script&lang=js"
export * from "./LastServiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports